// src/constants/crypto.constants.ts
// ============= CRYPTO CONSTANTS (ESLint compliant) =============

/**
 * AES encryption constants
 */
export const AES_KEY_SIZE_BYTES = 32;
export const AES_KEY_SIZE_BITS = 256;
export const AES_IV_SIZE_BYTES = 12;
export const AES_AUTH_TAG_SIZE_BYTES = 16;
export const AES_AUTH_TAG_SIZE_BITS = 128;

/**
 * Argon2 password hashing constants
 */
export const ARGON2_TIME_COST = 3;
export const ARGON2_MEMORY_COST = 4096;
export const ARGON2_HASH_LENGTH = 32;
export const ARGON2_PARALLELISM = 1;

/**
 * ML-KEM key generation constants
 */
export const MLKEM_SEED_SIZE_BYTES = 64;

/**
 * Hex conversion constants
 */
export const HEX_RADIX = 16;
export const HEX_PAD_LENGTH = 2;
export const HEX_PAD_CHAR = '0';

/**
 * Bit manipulation constants
 */
export const UINT16_SHIFT_BITS = 8;
export const BYTE_MASK = 0xFF;
